import React, { useEffect, useState } from 'react';
import { Quill } from 'react-quill';
import { ITask, updateTaskDetails } from '../../../firebase/api/tasks-public';
import { Wrapper, Title, Controls, SReactQuill } from './styled';
import './quill.css';

const Font = Quill.import('formats/font');

Font.whitelist = ['FSAlbert', 'Arial', 'Times-New-Roman', 'Roboto'];
Quill.register(Font, true);

interface IProps {
  setDetailsVisible: (value: boolean) => void;
  isDetailsVisible: boolean;
  task: ITask;
  boardId: string;
}

const TaskDetails: React.FC<IProps> = (props) => {
  const [details, setDetails] = useState(props.task.text || '');
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    props.isDetailsVisible && !!props.task.text && setIsEditing(false);
    props.isDetailsVisible && !props.task.text && setIsEditing(true);
  }, [props.isDetailsVisible, props.task.image, props.task.text]);

  const saveDetails = () => {
    updateTaskDetails(props.boardId, props.task.id, details);
  };

  return (
    <Wrapper isDetailsVisible={props.isDetailsVisible}>
      <Title>
        Детали задачи
        <div>
          {!!props.task.text && !isEditing && (
            <button onClick={() => setIsEditing(true)} className="edit" style={{ marginRight: 5 }}>
              Редактировать
            </button>
          )}
          <button onClick={() => props.setDetailsVisible(false)} className="close-details">
            Закрыть
          </button>
        </div>
      </Title>
      <SReactQuill
        theme="snow"
        value={details}
        onChange={(e: string) => {
          setDetails(e);
        }}
        isEditing={isEditing}
        modules={{
          toolbar: !isEditing
            ? false
            : [
                [{ header: [1, 2, 3, 4, 5, 6, false] }, { font: Font.whitelist }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
                ['link', 'image'],
                ['clean'],
              ],
        }}
        formats={[
          'header',
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'list',
          'bullet',
          'indent',
          'link',
          'image',
          'font',
        ]}
      />
      <Controls>
        <button
          style={{
            visibility: isEditing ? 'visible' : 'hidden',
          }}
          disabled={!details}
          onClick={saveDetails}
        >
          Сохранить
        </button>
      </Controls>
    </Wrapper>
  );
};

export default TaskDetails;
